<div class="sectionContainer paddedContent containerMargins">
  <div class="defaultMargins">
    <span style="font-weight: bold">Support</span><br />
    <!-- this will be based on the merchant's brand id-->
    <div style="font-size: 0.9em">
      support&#64;swipesum.com<br />
      844-356-9905
    </div>

    <div style="font-size: 0.9em" [hidden]="brand != 'Fast Signs'">
      FASTSIGNS&#64;swipesum.com<br />
      844-222-7155
    </div>
  </div>

  <div class="defaultMargins" [hidden]="gatewaySupport.name == ''">
    <span style="font-weight: bold">Your Gateway</span>
    <div style="font-size: 0.9em">
      {{ gatewaySupport.name }}<br />
      {{ gatewaySupport.url }}<br />
      {{ gatewaySupport.phone }}
    </div>
  </div>

  <div [hidden]="processorSupport.name == ''">
    <span style="font-weight: bold">Your Processor</span>

    <div style="display: table; font-size: 0.9em">
      {{ processorSupport.name }}

      <div style="display: table-row">
        <div style="display: table-cell; padding-right: 8px">
          Merchant Support
        </div>
        <div style="display: table-cell">
          {{ processorSupport.supportPhone }}
        </div>
      </div>
      <div
        style="display: table-row"
        [hidden]="processorSupport.pciPhone == ''"
      >
        <div style="display: table-cell; padding-right: 8px">
          PCI Assistance
        </div>
        <div style="display: table-cell">
          {{ processorSupport.pciPhone }}
        </div>
      </div>
    </div>
  </div>
</div>
